import type * as React from 'react';
import homeLeft, { type HomeLeftAction } from '@Application/Indicators/Actions/homeLeft';

/** Empties the home figures, so the next visit reads them again. */
export default () => {
	return async (dispatch: React.Dispatch<HomeLeftAction>): Promise<HomeLeftAction> => {
		const action = homeLeft();
		dispatch(action);
		return action;
	};
};
